export const viewFile = {
  image: 'jpg/png/jpeg/gif/bmp',
  office: 'csv/xlsx/docx/pptx/ppt/wps',
  audio: 'mp3',
  pdf: 'pdf',
  video: 'mp4',
  txt: 'txt'
}

export const previewExtensions = new Set(
  Object.values(viewFile).flatMap((formats) => formats.split('/'))
)
